import React, { useState, useEffect, useCallback } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";

// Público
import Landing from "./components/Landing";
import Login from "./components/Login";
import Register from "./components/Register";

// Layout privado
import LayoutPrivado from "./layouts/LayoutPrivado";

// Páginas privadas nuevas
import Dashboard from "./pages/Dashboard";
import Listas from "./pages/Listas";
import DetalleLista from "./pages/DetalleLista";
import Salas from "./pages/Salas";
import SalaDetalle from "./pages/SalaDetalle";

// Páginas existentes del proyecto
import Profile from "./components/Profile";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Mensajes from "./pages/Mensajes";
import Compare from "./pages/Compare";
import AdminOCR from "./pages/AdminOCR.jsx";
import MapaTiendas from "./pages/MapaTiendas.jsx";
import Novedades from "./pages/Novedades.jsx";
import Historico from "./pages/Historico.jsx";
import ScannerPage from "./pages/ScannerPage";

/**
 * Ruta privada: si no hay token, redirige a /login.
 */
function PrivateRoute({ children }) {
    const token = localStorage.getItem("token");
    if (!token) {
        return <Navigate to="/login" replace />;
    }
    return children;
}

export default function MainRoutes() {
    const [usuario, setUsuario] = useState(localStorage.getItem("user_nombre") || "");
    const [foto, setFoto] = useState(localStorage.getItem("user_foto") || "");
    const navigate = useNavigate();

    // Escucha actualizaciones de perfil
    useEffect(() => {
        const syncProfile = () => {
            setUsuario(localStorage.getItem("user_nombre") || "");
            setFoto(localStorage.getItem("user_foto") || "");
        };
        window.addEventListener("user:updated", syncProfile);
        window.addEventListener("storage", syncProfile);
        return () => {
            window.removeEventListener("user:updated", syncProfile);
            window.removeEventListener("storage", syncProfile);
        };
    }, []);

    /**
     * Login normal (email/password)
     */
    const handleLoginSuccess = useCallback(() => {
        setUsuario(localStorage.getItem("user_nombre") || "");
        setFoto(localStorage.getItem("user_foto") || "");
        navigate("/dashboard");
    }, [navigate]);

    /**
     * Login Google (callback desde backend)
     */
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const t = params.get("token");
        const nombre = params.get("nombre");
        const fotoParam = params.get("foto");
        const emailParam = params.get("email");

        if (t && nombre) {
            localStorage.setItem("token", t);
            localStorage.setItem("user_nombre", nombre);
            if (fotoParam) localStorage.setItem("user_foto", fotoParam);
            if (emailParam) localStorage.setItem("user_email", emailParam.toLowerCase());

            // Limpia la URL
            window.history.replaceState({}, document.title, "/");

            setUsuario(nombre);
            setFoto(fotoParam || "");
            navigate("/dashboard");
        }
        // eslint-disable-next-line
    }, [navigate]);

    /**
     * Logout
     */
    const handleLogout = useCallback(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user_nombre");
        localStorage.removeItem("user_foto");
        localStorage.removeItem("user_email");
        localStorage.removeItem("user");
        navigate("/login");
    }, [navigate]);

    return (
        <Routes>
            {/* -------------------- */}
            {/* RUTAS PÚBLICAS       */}
            {/* -------------------- */}
            <Route
                path="/"
                element={
                    <Landing
                        onLoginClick={() => navigate("/login")}
                        onRegisterClick={() => navigate("/register")}
                    />
                }
            />

            <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />
            <Route path="/register" element={<Register />} />

            <Route path="/forgot" element={<ForgotPassword onGoBack={() => navigate("/login")} />} />
            <Route path="/reset" element={<ResetPassword onGoBack={() => navigate("/login")} />} />

            {/* -------------------- */}
            {/* RUTAS PRIVADAS       */}
            {/* -------------------- */}
            <Route
                element={
                    <PrivateRoute>
                        <LayoutPrivado usuario={usuario} foto={foto} onLogout={handleLogout} />
                    </PrivateRoute>
                }
            >
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/salas" element={<Salas />} />
                <Route path="/salas/:idSala" element={<SalaDetalle />} />

                <Route path="/listas" element={<Listas />} />
                <Route path="/listas/:idLista" element={<DetalleLista />} />


                <Route path="/mensajes" element={<Mensajes />} />
                <Route path="/compare" element={<Compare />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/admin/ocr" element={<AdminOCR />} />
                <Route path="/tiendas" element={<MapaTiendas />} />
                <Route path="/novedades" element={<Novedades />} />
                <Route path="/historico" element={<Historico />} />
                <Route path="/scan" element={<ScannerPage />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
}
